export default "/assets/exclamation-gray.svg";